import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getCostLineDecisions } from "entities/CostLines";
import { getRejectionData } from "entities/CostLines/utils/getRejectionData";
import { OCRClassifications } from "entities/OCR";
import CostLineAcceptanceActionsBar from "modules/Expenses/components/CostLineAcceptanceActionsBar/CostLineAcceptanceActionsBar";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ROLES } from "shared/config";
import Icons from "shared/icons";
import { serializeObject } from "shared/utils";

function CostLineFooter({ idx, userRole, costLine, access, costLinesRefs }) {
  const { t } = useTranslation("CostLine");

  const { isAccepted, isRejected } = getCostLineDecisions(costLine, userRole);

  const rejection = getRejectionData(
    costLine?.acceptations,
    costLine?.rejection_history
  );

  const forCostGroupApprovalOnly =
    costLine.fast_track &&
    [ROLES.SUPERVISOR, ROLES.ADDITIONAL_ACCEPTOR].includes(userRole);

  const ocrClassifications = serializeObject(
    costLine.attachments.data.find(
      (attachment) => !Array.isArray(attachment.ocr_classifications.data)
    )?.ocr_classifications?.data
  );

  if (userRole === ROLES.USER) {
    if (isRejected)
      return (
        <>
          <Stack
            direction="horizontal"
            className="align-items-start border-top pt-4 mt-4 px-3 text-danger"
            gap={4}
          >
            <FontAwesomeIcon
              style={{ height: "0.9rem", marginTop: "2px" }}
              icon={isRejected ? Icons.triangleExclamation : Icons.check}
            />

            <div>
              <h6 className="fw-bolder text-start">{t("labels.rejection")}</h6>
              {/* lack of comment is returned as a string "null" ¯\_(ツ)_/¯ */}
              {rejection?.comment !== "null" && rejection?.comment !== "" && (
                <p className="m-0">
                  <strong>{t("labels.rejection_comment")}</strong>{" "}
                  {rejection?.comment}
                </p>
              )}
              {rejection?.rejection_reasons?.data?.length > 0 && (
                <div>
                  <strong>{t("labels.rejection_reason")}</strong>
                  <ul className="m-0">
                    {rejection?.rejection_reasons?.data?.map((reason, idx) => (
                      <li key={idx}>{reason?.rejection_name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </Stack>
        </>
      );
    else if (ocrClassifications)
      return <OCRClassifications classifications={ocrClassifications} />;
  } else {
    return (
      <>
        {forCostGroupApprovalOnly ? (
          <p className="fw-bolder text-start mt-4 text-success">
            {t("for_cost_group_approval_only", {
              ns: "CostGroup",
            })}
          </p>
        ) : (
          <CostLineAcceptanceActionsBar
            idx={idx}
            userRole={userRole}
            costLine={costLine}
            isAccepted={isAccepted}
            isRejected={isRejected}
            rejection={rejection}
            isEditable={access
              .to("CostLine", "makeDecision")
              .withLock()
              .withHold()
              .provided()}
            costLinesRefs={costLinesRefs}
          />
        )}
      </>
    );
  }
}

export default CostLineFooter;
